export default __webpack_public_path__ + "static/media/situation-coref-assign-entity-type.dcabd1c6.gif";